@import "../../../global/gx-ide-common";

ch-popover {
  background-color: var(--color-accent-surface-elevation-1);
  border: 1px solid var(--color-border-surface-on-surface);
  border-radius: var(--border-radius-s);
  box-shadow: var(--shadow-elevation-2);

  > div {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: var(--spacing-padding-m);
    max-block-size: 300px;
    overflow-y: auto;
  }
}

.checkbox-item {
  display: flex;
  inline-size: 100%;
  padding-block: var(--spacing-padding-xs);
  padding-inline: var(--spacing-padding-m);
  cursor: pointer;
  border-radius: var(--border-radius-s);

  &:hover {
    background-color: var(--color-accent-item-selected);
  }

  &::part(checkbox) {
    inline-size: 100%;
  }

  &::part(label) {
    inline-size: 100%;
    cursor: pointer;
    flex: 1;
  }
}

.multi-select {
  &__button {
    display: flex;
    align-items: center;
    gap: var(--spacing-gap-s);
    overflow: hidden;
  }

  &__chevron {
    flex-shrink: 0;
    margin-inline-start: auto;
  }

  &__placeholder {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-gap-xs);
    flex: 1;
    align-items: center;
  }

  &__item {
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-gap-xs);
    padding: 2px var(--spacing-padding-xs);
    background-color: var(--color-accent-item-pressed);
    border-radius: var(--border-radius-s);

    & button {
      padding: 0;
    }
  }

  &__caption {
    color: var(--color-text-neutral-on-disabled);
  }

  &__close {
    padding: 0;
    margin: 0;
  }
}

ch-checkbox.checkbox::part(label) {
  font-weight: var(--font-style-regular);
  color: var(--color-text-neutral-default);
}
